export const queryWhyOnshape = groq`*[_type == "whyOnshape" && currentPathname == $currentPathname][0]{
    ...,
  "whyOnshapeHero": {
    title,
    description,
    heroImage,
    video,
    subtitle
  }
}`;
